import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  primary: {
    lighten: '#1F7C74',
    default: '#15534E',
    dim: 'rgba(21,83,78,0.4)',
    mute: 'rgba(21,83,78,0.1)',
  },
  gray: {
    '100': '#ffe',
    '000': '#000',
    '010': '#070707',
    main: '#072523',
    '020': '#15322F',
    '030': '#243F3B',
    '040': '#334C47',
    '050': '#3B524D',
    '060': '#455B55',
    '070': '#566A63',
    '080': '#839288',
    '090': '#A5B0A4',
  },
  green: {
    lighten: '#3CA371',
    default: '#2E7E57',
    dim: 'rgba(46,126,87,0.4)',
    mute: 'rgba(46,126,87,0.1)',
  },
  red: {
    lighten: '#C74454',
    default: '#A63240',
    dim: 'rgba(166,50,64,0.4)',
    mute: 'rgba(166,50,64,0.1)',
  },
  yellow: {
    lighten: '#D7BD66',
    default: '#CCAC3E',
    dim: 'rgba(204,172,62,0.4)',
    mute: 'rgba(204,172,62,0.1)',
  },
  orange: {
    lighten: '#FF6C1A',
    default: '#E65200',
    dim: 'rgba(230,82,0,0.4)',
    mute: 'rgba(230,82,0,0.1)',
  },
  blue: {
    lighten: '#61A8F0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#A778E2',
    default: '#8B4ED9',
  },
  white: {
    default: '#FFFFFF',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const DarkAurosTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkAuros',

  colorTextDefaultButton: colors.white.default,
  colorTextDefaultButtonHover: colors.white.default,
  colorTextDefaultButtonFocus: colors.white.default,
  colorTextDefaultButtonActive: colors.white.default,
  colorTextDefaultButtonDisabled: setAlpha(0.5, colors.white.default),

  colorTextWarningButton: colors.black.default,
  colorTextWarningButtonHover: colors.black.default,
  colorTextWarningButtonFocus: colors.black.default,
  colorTextWarningButtonActive: colors.black.default,
  colorTextWarningButtonDisabled: setAlpha(0.5, colors.black.default),

  colorTextMutedButton: colors.white.default,
  colorTextMutedButtonHover: colors.white.default,
  colorTextMutedButtonFocus: colors.white.default,
  colorTextMutedButtonActive: colors.white.default,
  colorTextMutedButtonDisabled: setAlpha(0.5, colors.white.default),
});
